// usersSlice.ts
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import services from "../../services/services";

interface Pagination {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

interface UserState {
  users: any[];
  pagination: Pagination;
  isLoading: boolean;
  isError: boolean;
  error: string;
}

const initialState: UserState = {
  users: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  },
  isLoading: false,
  isError: false,
  error: "",
};

export const getallUsersThank = createAsyncThunk<any, any>(
  "users/fetchAll",
  async (params: any) => {
    const response = await services.getUser(params);
    return response;
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    resetUsers: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getallUsersThank.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getallUsersThank.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload.data || [];
        state.pagination = action.payload.pagination || initialState.pagination;
      })
      .addCase(getallUsersThank.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error.message || "Failed to fetch users";
      });
  },
});

export const { resetUsers } = usersSlice.actions;
export default usersSlice.reducer;
